import React from "react";
import { useTheme } from "@mui/material/styles";
import {
  AppBar,
  Box,
  CircularProgress,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import { Outlet, useNavigate } from "react-router";
import { useMutation, useQuery } from "react-query";
import { logout } from "../../utils/api/auth/logout";
import { useAuthDataContext } from "../../utils/storages/authDataProvider";
import { ListOutlined } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { getUser } from "../../utils/api/auth/getUser";

const drawerWidth = 280;

export default function Layout() {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { onLogout } = useAuthDataContext();
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const defaultMenu = [
    { id: "categories", label: "‌دسته بندی‌ها", icon: <DashboardIcon />, link: "/panel/categories" },
  ];

  const items = defaultMenu;

  const logoutMutation = useMutation("logout-mutation", () => logout(), {
    onSuccess: (data) => {
      localStorage.removeItem("user");
      onLogout();
      navigate("/login");
    },
    onError: (error) => {
      localStorage.removeItem("user");
      onLogout();
      navigate("/login");
    },
  });

  const { enqueueSnackbar } = useSnackbar();

  const getUserQuery = useQuery("get-user-query", (data) => getUser(data), {
    onSuccess: (data) => {},
    onError: (error) => {
      enqueueSnackbar("توکن منقضی شده، مجددا وارد شوید.", { variant: "error" });
      localStorage.removeItem("user");
      onLogout();
      navigate("/login");
    },
  });

  const drawer = (
    <div>
      <Toolbar sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2 }}>
        <Typography variant='h6' noWrap component='div'>
          کافه پاییز - پنل مدیریت
        </Typography>
      </Toolbar>
      <List>
        {items.map((item) => (
          <ListItemButton
            key={item.id}
            onClick={() => {
              navigate(item.link);
              if (!isMdUp) setMobileOpen(false);
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position='fixed'
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          {!isMdUp && (
            <IconButton
              aria-label='open drawer'
              edge='start'
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { md: "none" } }}
            >
              <MenuIcon />
            </IconButton>
          )}

          <Typography variant='h6' noWrap component='div' sx={{ flexGrow: 1 }}>
            پنل مدیریت
          </Typography>

          <IconButton size='large' aria-label='show ' onClick={() => logoutMutation.mutate()}>
            {logoutMutation.isLoading ? <CircularProgress size={10} /> : <LogoutIcon />}
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box component='nav' sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }} aria-label='mailbox folders'>
        <Drawer
          variant='temporary'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>

        <Drawer
          variant='permanent'
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />

        <Outlet />
      </Box>
    </Box>
  );
}
